import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import { addPxSuffix } from '@/src/helpers';

type Props = {
  $white?: boolean;
  $outlined?: boolean;
  $disabled?: boolean;
  $center?: boolean;
  $fullWidth?: boolean;
  $color?: 'white' | 'black';
  $margin?: string | number;
  $mobileFullWidth?: boolean;
};

const StyledButtonCss = css<Props>`
  width: ${({ $fullWidth, $mobileFullWidth }) =>
    $fullWidth || $mobileFullWidth ? '100%' : 'max-content'};
  max-width: 100%;
  min-width: 144px;
  border: 1px solid ${({ theme, $color }) => theme.colors[$color ?? 'black']};
  padding: 11px 20px;
  height: 50px;
  background: ${({ theme, $outlined, $color }) =>
    $outlined ? `rgba(0, 0, 0, 0.00)` : theme.colors[$color ?? 'black']};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  text-decoration: none;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: ${({ $center }) => ($center ? 'center' : 'auto')};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.77 : 1)};
  margin: ${({ $margin }) => addPxSuffix($margin ?? 0)};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    transition: all 0.2s ease-in-out;
    width: ${({ $mobileFullWidth }) => $mobileFullWidth && 'max-content'};
    padding: 11px 16px;
    height: 42px;

    &:hover {
      background: ${({ theme }) => theme.colors.orangePeel};
      border: 1px solid ${({ theme }) => theme.colors.orangePeel};
    }
  }
`;

const Button = styled.button<Props>`
  ${StyledButtonCss}
`;

const InternalLink = styled(Link)<Props>`
  ${StyledButtonCss}
`;

const ExternalLink = styled.a<Props>`
  ${StyledButtonCss}
`;

const S = {
  Button,
  InternalLink,
  ExternalLink,
};

export default S;
